import { ControlType, type ControlProps, type Option } from '../../../Form';
import { parseCountFromAddLabel } from '../../../Filters/verticalFilters/utils';

const getControlFromName = (name?: string, controls?: ControlProps[]) =>
  controls?.filter((control) => control?.name === name);

const getOptionFromValue = (value?: string, options?: Option[]) =>
  options?.filter((option) => option?.value === value) || [];

export const getDisabled = (currentOption?: Option, currentAddLabel?: string) => {
  if (currentOption === undefined && currentAddLabel === undefined) return true;
  if (currentOption && currentAddLabel && parseCountFromAddLabel(currentAddLabel) === 0) return true;
  return false;
};

const getAddLabel = (controls: ControlProps[], name?: string, value?: string, container?: string) => {
  const currentContainer = getControlFromName(container, controls);
  const currentControl = getControlFromName(name, currentContainer?.[0]?.controls);
  const currentOption = getOptionFromValue(value, currentControl?.[0]?.options)?.[0];
  const currentAddLabel = currentOption?.addLabel;

  return {
    addLabel: currentAddLabel,
    disabled: getDisabled(currentOption, currentAddLabel),
  };
};
export const updateFiltersWithCurrentOrder = (controls: ControlProps[], newControls: ControlProps[]): ControlProps[] =>
  controls?.map((x) => ({
    ...x,
    controls: x?.controls?.map((control) => {
      if (control?.control === ControlType.LISTBOX) {
        return {
          ...control,
          options: control?.options?.map((option) => ({
            ...option,
            ...getAddLabel(newControls, control?.name, option?.value, x?.name),
          })),
        };
      }

      return control;
    }),
  }));
